import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      color: theme.colors.greySemiDark,
      marginBottom: 16,
    },
    separator: {
      marginRight: 4,
      fill: theme.colors.greySemiDark,
    },
    li: {
      transition: '.3s',
      '&:last-of-type': {
        color: theme.colors.black,
        '& svg': {
          fill: theme.colors.black,
        },
      },
      '&:hover': {
        color: theme.colors.black,
        '& svg ': {
          fill: theme.colors.black,
        },
      },
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      '& svg ': {
        marginRight: 8,
        fill: theme.colors.greySemiDark,
      },
    },
  })
)
